import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

// The type of your refresh function might be different based on your implementation.
type RefreshTokenFunction = () => Promise<string>

interface PendingPromise {
  resolve: (value: string) => void
  reject: (reason: any) => void
}

let isRefreshing = false
let failedQueue: PendingPromise[] = []

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token!)
    }
  })

  failedQueue = []
}

export function createAuthInterceptor(apiClient: AxiosInstance, refreshToken: RefreshTokenFunction, openSnackBar: any) {
  apiClient.interceptors.response.use(
    (response: AxiosResponse) => response,
    async (err) => {
      const originalRequest = err.config as AxiosRequestConfig & { _retry: boolean }
      if (err.response?.status === 401 && !originalRequest._retry) {
        if (isRefreshing) {
          return new Promise<string>((resolve, reject) => {
            failedQueue.push({ resolve, reject })
          })
            .then((token) => {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              originalRequest.headers['x-access-token'] = token
              return apiClient(originalRequest)
            })
            .catch((err) => Promise.reject(err))
        }

        originalRequest._retry = true
        isRefreshing = true

        return new Promise((resolve, reject) => {
          refreshToken()
            .then((token) => {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              originalRequest.headers['x-access-token'] = token
              processQueue(null, token)
              resolve(apiClient(originalRequest))
            })
            .catch((err) => {
              processQueue(err, null)
              reject(err)
            })
            .then(() => {
              isRefreshing = false
            })
        })
      }
      if (
        err.response?.status === 401 &&
        err.response?.data?.message &&
        err.response?.data?.message === 'You do not have access to this functionality.'
      ) {
        openSnackBar({
          message: 'You do not have access to this functionality.',
          type: 'error',
          priority: 1,
        })
      }
      return Promise.reject(err)
    },
  )
}
